import React from "react";

class UserDataForm extends React.Component {


    render() {

        return (
            <>
                <div className="form-row--multiple">
                    <div className="form-item">
                        <label htmlFor="firstname">First Name</label>
                        <div className="input-input">
                            <figure className="form-icon--valid">
                                <img src="/static/media/checkmark.svg"
                                     alt="Formular Icon"/>
                            </figure>
                            <input id="firstname" type="text" placeholder="Use at least 2 letters" name="firstname" required
                                   minLength="2" data-message="You should write something here"
                                   onInput={this.props.checkme}/>
                        </div>
                    </div>
                    <div className="form-item">
                        <label htmlFor="lastname">Last Name</label>
                        <div className="input-input">
                            <figure className="form-icon--valid">
                                <img src="/static/media/checkmark.svg"
                                     alt="Formular Icon"/>
                            </figure>
                            <input id="lastname" type="text" placeholder="Use at least 2 letters" name="lastname" required
                                   minLength="2" data-message="Hmm, something missing?" onInput={this.props.checkme}/>
                        </div>
                    </div>
                    <div className="form-item">
                        <label htmlFor="email">Email</label>
                        <div className="input-input">
                            <figure className="form-icon--valid">
                                <img src="/static/media/checkmark.svg"
                                     alt="Formular Icon"/>
                            </figure>
                            <input id="email" type="email" placeholder="" name="email" required
                                   data-message="OK, I get it. You don't want any emails, right?"
                                   onInput={this.props.checkme}/>
                        </div>
                    </div>
                </div>
            </>
        )

    }
}


export default UserDataForm;
